import { Navigate, useSearchParams } from 'react-router-dom'
import { isCheckoutCompleted } from './Helpers/guestCheckoutCompletion'

const CompletedGuestCheckoutGuard = ({ children }) => {
    const [searchParams] = useSearchParams()
    const uuid = searchParams.get('uuid')

    if (isCheckoutCompleted(uuid)) {
        return <Navigate to="/" replace />
    }

    return children
}

export default CompletedGuestCheckoutGuard
